module.exports = __webpack_public_path__ + "media/luxury-2026/sculptural-sitting-room-960-fd4a7a91.jpg";